// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var orange = (_obj = {}, _define_property(_obj, 50, '#FFF3E6'), _define_property(_obj, 100, '#FEECD7'), _define_property(_obj, 200, '#FEDCB3'), _define_property(_obj, 300, '#FDC086'), _define_property(_obj, 400, '#FFA970'), _define_property(_obj, 500, '#FF8044'), _define_property(_obj, 600, '#F26B2C'), _define_property(_obj, 700, '#DC5618'), _define_property(_obj, 800, '#A54112'), _define_property(_obj, 900, '#6B2C0F'), _define_property(_obj, 950, '#3C1401'), _obj);

//# sourceMappingURL=orange.js.map